import gsap from 'gsap'
// import { Power2 } from 'gsap'
import koko from '../koko-framework/koko'
import { au } from '../koko-framework/shorthand'
import app from '../koko-framework/app'
// import * as PIXI from 'pixi.js'
// import gameState from '../model/GameModel'
import { setupClicker } from '../controller/ButtonController'

export class ClearPop extends koko.view {
    currentGameView = null;

    /* constructor (){
        super();
    } */

    buildView (){
        var vp = app.viewPort;

        this.children = koko.display.buildLayout([
            { type: 'shape', name: 'bg', x: -280, y: 0, width: 1326, height: 1355, fill: 0, alpha: 0.6},
            { type: 'sprite', id: 'clear_popupCarrier', name: 'bg2', x: vp.centerX, y: vp.centerY, width: 642, height: /*588*/373, anchorX: 0.5, anchorY: 0.5},
            { type: 'sprite', id: 'clearall_title', name: 'title', x: vp.centerX, y: 608, width: 198, height: 63, anchorX: 0.5, anchorY: 0.5},
            { type: 'bmptext', text: 'Are you sure you want to clear\nall entries?', font: 'typrighter_small', size: 30, tint: 0, name: 'text', align:'center', x: vp.centerX, y: 665, anchorX: 0.5, anchorY: 0},
            { type: 'sprite', id: 'close_btn', name: 'close_btn', x: 607, y: 568, width: 75, height: 63, anchorX: 0.5, anchorY: 0.5},
            { type: 'sprite', id: 'clearall_btn', name: 'clearall_btn', x: vp.centerX - 100, y: 788, width: 162, height: 55, anchorX: 0.5, anchorY: 0.5},
            { type: 'sprite', id: 'clearall_cancel_btn', name: 'clearall_cancel_btn', x: vp.centerX + 100, y: 788, width: 162, height: 55, anchorX: 0.5, anchorY: 0.5},
        ], this.container);

        this.resize();

        /*
        let event = koko.client.system.isMobile ? 'touchstart' : 'mousedown';

        this.children.close_btn.interactive = true;
        this.children.close_btn.on(event, this.closePop);

        this.children.mainmenu_btn.interactive = true;
        this.children.mainmenu_btn.on(event, this.quitGame);
        */
    }

    resize () {
        /*
        var vp = app.viewPort;
        let bg = this.children.bg;
        bg.width = vp.width + Math.abs(vp.x) * 4;
        bg.height = vp.height + Math.abs(vp.y) * 4;
        bg.x = vp.centerX - bg.width / 2;
        bg.y = vp.centerY - bg.height / 2;
        */
    }

    transitionIn = (currentGameView = null) => {
        this.currentGameView = currentGameView;
        this.buildView();
        this.show();
        this.enable();
        this.container.alpha = 0;
        gsap.to(this.container, {alpha:1, duration: 0.35, onComplete: this.transitionInDone});

        // setTimeout(this.transitionOut, 5000);
        au.playRandom('pop', 1, 10);
    }

    transitionInDone = () => {
        setupClicker(this.children.close_btn, this.closePop);
        setupClicker(this.children.clearall_cancel_btn, this.closePop);
        setupClicker(this.children.clearall_btn, this.clearAllLetters);
    }

    transitionOut = () => {
        this.children.close_btn.interactive = false;
        this.children.clearall_btn.interactive = false;
        this.children.clearall_cancel_btn.interactive = false;

        gsap.to(this.container, {alpha:0, onComplete:this.transitionOutDone, duration: 0.35});
    }

    transitionOutDone = () => {
        // gsap.killAll();
        // this.destroyGameObjects();  
        // game.destroy();
        // game = null;
        this.destroyView();
        this.hide();

        /*
        PIXI.Ticker.shared.stop();
        app.renderer.renderer.plugins.interaction.destroy();

        app.paused = true;
        app.renderer.destroy();
        PIXI.utils.destroyTextureCache();
        */
    }

    closePop = (e) => {
        au.play('button', 1, false);
        if (this.currentGameView && this.currentGameView.popClosed) {
            this.currentGameView.popClosed();
        }
        this.transitionOut();
    }

    clearAllLetters = (e) => {
        if (this.currentGameView && this.currentGameView.clearAllLetters) {
            this.currentGameView.clearAllLetters();
        }
        this.closePop();
    }
}